export default __webpack_public_path__ + "static/media/external-link-white.c2554f72.svg";